/**
 * @param {{ buildId: string, builtAt?: string | null }} local
 * @param {{ buildId: string | null, builtAt?: string | null }} remote
 */
export function isUpdateAvailable(local, remote) {
  const remoteBuildId = remote?.buildId
  if (!remoteBuildId) return false
  const localBuildId = local?.buildId || 'dev'
  if (remoteBuildId !== 'dev' || localBuildId !== 'dev') {
    if (remoteBuildId !== localBuildId) return true
  }
  const localBuiltAt = local?.builtAt
  const remoteBuiltAt = remote?.builtAt
  if (localBuiltAt && remoteBuiltAt && remoteBuiltAt !== localBuiltAt) {
    return remoteBuiltAt > localBuiltAt
  }
  return false
}
